import {Component} from '@angular/core';

import {AuthHttpService} from "../../../services/auth-http.service";
import {MatDialog} from '@angular/material/dialog';

import {TranslateService} from '@ngx-translate/core';
import {Globals} from '../../../globals';
import {forkJoin, Subscription} from 'rxjs';

import {SensorsService} from '../../../services/sensors.service';
import {AvatarService} from '../../../services/avatar.service';
import {UserService} from '../../../services/user.service';
import {Router} from "@angular/router";

import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-admin-headers',
  templateUrl: './admin-headers.component.html',
  styleUrls: ['./admin-headers.component.scss']
})
export class AdminHeadersComponent {
  name: string;
  role = '';
  error_data: string;
  projects = [];

  // новый вывод верхнего меню массивом c привилегиями
  topMenu = [];
  topMenu_lang = [];
  top_menu_done = false;
  user_data: any;
  user_projects: any[] = [];

  items: MenuItem[];

  road_editor_lang: string;
  road_type: string;
  lane_type: string;
  cabinets_lang: string;
  sensors_lang: string;
  adapters_lang: string;

  roadPages: any[];
  equipment_menu: any[];

  // Subscriptions
  changeLangCancel: Subscription;
  user_sub: Subscription;
  langSubscription: Subscription;

  constructor(
    private http: AuthHttpService,
    public dialog: MatDialog,
    public Globals: Globals,
    public translate: TranslateService,
    private sensorsService: SensorsService,
    public AvatarService: AvatarService,
    private UserService: UserService,
    private router: Router
  ) {

    Globals.error = true;
    this.Globals.lang_select = this.Globals.lang;

    //показываем селект выбора проекта в зависимости от url
    this.Globals.checkRoute();

    //translate
    this.changeLangCancel = this.Globals.langJS.subscribe(() => {
      this.onLangChanged();
      this.translate.use(this.Globals.lang)
    });

    //this.onLangChanged();
    this.Globals.hiddenAdmin = false;

    this.getUser();
  }

  getUser() {
    //проверяем заполнен ли глобальный юзер, если нет, загружаем
    let recieved_user: any = this.UserService.getUserGlobalData();

    let get_projects = (user_data: { role: { roles_id: string; }; projects_all: any[]; projects: any[]; }) => {
      let projects_arr = [];
      if (user_data?.role.roles_id == this.Globals.superadmin) {
        projects_arr = user_data.projects_all;
      } else {
        projects_arr = user_data?.projects;
      }
      this.user_projects = projects_arr;
    }

    if (Boolean(recieved_user)) {
      this.user_data = JSON.parse(JSON.stringify(this.UserService.getUserGlobalData()));
      get_projects(this.user_data);
      this.afterGet();
    } else {
      this.user_sub = this.UserService.user().subscribe((user) => {
        this.user_data = JSON.parse(JSON.stringify(user));
        get_projects(this.user_data);
        this.afterGet();
      });
    }
  }

  afterGet() {
    //здесь если вдруг в localstorage оказался проект, которого нет у юзера, удаляем его оттуда
    if (Boolean(localStorage.project)) {
      let storage_project_id = localStorage.project;
      let user_projects_ids_arr = [];
      if (Boolean(this.user_projects) && this.user_projects.length) {
        this.user_projects.forEach(p => {
          user_projects_ids_arr.push(p.projects_id);
        })
      }
      if (!user_projects_ids_arr.includes(storage_project_id)) {
        localStorage.removeItem('project');
      }
    }

    if (Boolean(this.user_data)) {
      if (Boolean(localStorage.project)) {
        this.changeProjectSelect(localStorage.project)
      } else if (this.Globals.user.projects.length) {
        this.changeProjectSelect(this.user_projects[0].projects_id);
      }

      this.name = this.user_data['firstname'].toString() + ' ' + this.user_data['lastname'].toString();
      if (Boolean(this.user_data.role)) {
        this.role = this.user_data.role.name;
      }

      //здесь мы смотрим, есть ли у юзера язык и если нет, добавляем в базу для него дефолтный (пока это язык браузера)

      if (Boolean(this.user_data.interface_language)) {
        this.Globals.lang = this.user_data.interface_language;
        //console.log('sessionStorage.lang', sessionStorage.lang);
        if (!sessionStorage.lang) {
          this.Globals.lang_select = this.user_data.interface_language;
        }
        this.changeLang_new();
      } else {
        let params: any = {'interface_language': this.Globals.lang, 'id': this.user_data.users_id};
        this.http.post('/api/users/user_data/update', params).subscribe(() => {

          //после загрузки обновляем глобального юзера в сервисе
          this.UserService.clearUserGlobalData();
          this.user_sub = this.UserService.user().subscribe((user) => {
            this.user_data = JSON.parse(JSON.stringify(user));
            this.Globals.lang = this.user_data.interface_language;
            this.Globals.lang_select = this.user_data.interface_language;
            this.changeLang_new();
          });
        });
      }

      //проверяем и выставляем аватар
      if (!Boolean(this.user_data.avatar_image)) {
        this.AvatarService.user_avatar_num = 5;
      } else {
        this.AvatarService.user_avatar_num = Number(this.user_data.avatar_image);
      }
    }
  }

  //проверяем были ли изменены данные в админке
  checkAdminChanges(code: any) {

    if (this.Globals.data_has_changed) {
      this.sensorsService.clearSensorsGlobalData();
      this.Globals.checkRoute();
      this.getUser();
      this.Globals.data_has_changed = false;
      return;
    }

  }


  //построение верхнего меню в соответствии с привелегиями юзера
  topMenuBuild() {

    let user_role: string;
    let user_privs = [];

    if (Boolean(this.Globals.user) && Boolean(this.Globals.user.role)) {
      user_role = this.Globals.user.role.roles_id;
      user_privs = this.Globals.user.role.privileges;

      //обозначим привелегии для всех пунктов верхнего меню и роль суперадмина
      //(id фиксированные, соответствуют  базе)

      let role_sup = this.Globals.superadmin; //для организаций и настроек разработчика

      //создадим исходный массив пунктов верхнего меню
      let topMenuDef = [
        {
          'name': this.topMenu_lang[0],
          'priv': "69770f3c-3047-f1e7-3f65-87f4792fc013",
          'link': ['/main'],
          'code': 'main'
        },
        {
          'name': this.topMenu_lang[1],
          'priv': "97dba9b4-4b97-f6aa-cfb8-f00665565e74",
          'link': null,
          'code': 'equipment'

        },
        // {
        //     'name': this.topMenu_lang[2],
        //     'priv': "97dba9b4-4b97-f6aa-cfb8-f00665565e74",
        //     'link': ['/admin/admin-sensors'],
        //     'code': 'sensors'
        // },
        {
          'name': this.topMenu_lang[2],
          'priv': "7f116e4f-018c-435b-93e0-327151cc5108",
          'link': ['/admin/users_roles'],
          'code': 'orgs'
        },
        {
          'name': this.topMenu_lang[3],
          'priv': "3e298e0c-7dcd-2c31-cdc5-cdc48eb7ac0b",
          'link': ['/admin/road-object-classes'],
          'code': 'classes'
        },
        {
          'name': this.topMenu_lang[4],
          'priv': "6970f523-4c18-74b5-bb4f-5cf9f8151e85",
          'link': ['/admin/logs'],
          'code': 'logs'
        },
        {
          'name': this.topMenu_lang[5],
          'priv': "9d9ffa59-9878-da1c-47a6-7db9ad5ce0bd",
          'link': ['/admin/events'],
          'code': 'events'
        },
        {
          'name': this.topMenu_lang[6],
          'priv': "f8c6ff2a-c67a-4cc7-9871-c1bc888fe2af",
          'link': null,
          'code': 'roads'
        },
        {
          'name': this.topMenu_lang[7],
          'priv': "7f116e4f-018c-435b-93e0-327151cc5108",
          'link': ['/admin/developer-settings'],
          'code': 'dev'
        },
      ];
      //проверяем привилегии и фильтруем список верхнего меню

      //проверяем роль суперадмина
      //и меняем ссылку с пункта  организации на проекты и скрываем настройки

      if (user_role != role_sup) {
        //скрываем настройки разработкика
        topMenuDef = topMenuDef.filter(tab => tab.code != 'dev');

        //меняем ссылку проекты и пользователи с организации на ту, у которой у юзера есть привилегии
        //если привелегий нет ни на что, скрывам пункт «проекты и пользователи»
        let org_tab = topMenuDef.find(tab => tab.code == 'orgs');

        let priv_proj = 'c89cacc5-e683-d4bb-1c93-3c29a3eaf448';
        let priv_users = '20ff326b-4970-c935-be8a-648272d6921d';
        let priv_roles = '8a4b4591-1825-e0d9-e0a3-1c34d83ac5cc';
        if (user_privs.findIndex(priv => priv.privileges_id == priv_proj) != -1) {
          org_tab.link = ['/admin/users_roles/project'];
        } else if (user_privs.findIndex(priv => priv.privileges_id == priv_users) != -1) {
          org_tab.link = ['/admin/users_roles/users'];
        } else if (user_privs.findIndex(priv => priv.privileges_id == priv_roles) != -1) {
          org_tab.link = ['/admin/users_roles/roles'];
        } else {
          topMenuDef = topMenuDef.filter(tab => tab.code != 'orgs');
        }
      }

      //проверяем есть ли привелегия по каждому пункту и скрываем соответствующие пункты меню
      topMenuDef.forEach(tab => {
        let count = 0;
        user_privs.forEach(priv => {
          let priv_id = priv.privileges_id;
          if (tab.code != 'orgs' && tab.code != 'dev' && tab.code != 'main') {
            if (priv_id != tab.priv) {
              count++;
            }
          }
        });
        if (count == user_privs.length) {
          topMenuDef = topMenuDef.filter(tb => tb.priv != tab.priv);
        }
      });

      // если запрещено редактирование дорог, скрываем пункт Управление дорогами
      let road_priv = user_privs.find(priv => priv.privileges_id == 'f8c6ff2a-c67a-4cc7-9871-c1bc888fe2af');
      if (Boolean(road_priv) && road_priv.mode == 0) {
        topMenuDef = topMenuDef.filter(tb => tb.priv != road_priv.privileges_id);
      }

      //если запрещено редактирование датчиков, скрываем пункт Оборудование

      let eqip_priv = user_privs.find(priv => priv.privileges_id == '97dba9b4-4b97-f6aa-cfb8-f00665565e74');

      if (Boolean(eqip_priv) && eqip_priv.mode == 0) {
        topMenuDef = topMenuDef.filter(tb => tb.priv != road_priv.privileges_id);
      }

      this.topMenu = JSON.parse(JSON.stringify(topMenuDef));

      //формируем новое меню primeNG

      this.items = [];
      this.topMenu.forEach(menu_item => {
        this.items.push(
          {
            label: menu_item.name,
            routerLink: menu_item.link,
            expanded: this.checkActiveState(menu_item.link),
            id: menu_item.code
          }
        )
      });

      //заполняем субменю для roads и equipment
      //предварительно нужно проверить права
      if (Boolean(road_priv) && road_priv.mode != 0) {
        let top_menu_roads = this.items.find(m => m.id == 'roads');
        top_menu_roads.items = [];
        this.roadPages.forEach(subitem => {
          top_menu_roads.items.push({
            label: subitem.name,
            routerLink: subitem.link
          })
        });
      }

      let top_menu_eq = this.items.find(m => m.id == 'equipment');
      top_menu_eq.items = [];
      this.equipment_menu.forEach(subitem => {
        top_menu_eq.items.push({
          label: subitem.name,
          routerLink: subitem.link
        })
      });

      this.top_menu_done = true;
      this.Globals.data_has_changed = false;
    } else {
      this.top_menu_done = true;
    }
  }

  //функция для выделения активного пункта меню при открытии страницы по ссылке
  checkActiveState(givenLink) {
    //console.log(this.router.url);
    if (Boolean(givenLink) && this.router.url.indexOf(givenLink) === -1) {
      return false;
    } else {
      return true;
    }
  }

  changeLangNew(e: any) {
    localStorage.setItem('lang', e);
    this.changeLang_new();
  }

  changeLang_new() {
    this.Globals.lang_select = localStorage.getItem('lang') ? localStorage.getItem('lang') : this.Globals.lang_select;
    this.Globals.lang = this.Globals.lang_select;
    this.translate.use(this.Globals.lang);
    this.Globals.langJS.next(this.Globals.lang);
    sessionStorage.setItem('lang', this.Globals.lang_select);
  }

  onLangChanged() {
    this.langSubscription = forkJoin([
      this.translate.get('error_data'), //0
      this.translate.get('mainPage'),//1
      this.translate.get('equipment'),//2
      //this.translate.get('sensors_menu'),//3
      this.translate.get('users_menu'),//3
      this.translate.get('classes_menu'),//4
      //this.translate.get('adapter_menu'),//5
      this.translate.get('logs_menu'),//5
      this.translate.get('events'),//6
      this.translate.get('road_menu'),//7
      this.translate.get('developer_settings'),//8
      this.translate.get('road_editor'),//9
      this.translate.get('road_types'), //10
      this.translate.get('types_of_lane'),//11
      this.translate.get('cabinets'),//12
      this.translate.get('sensors'),//13
      this.translate.get('adapter_menu')//14
    ]).subscribe((res) => {
      this.error_data = res[0];

      //добавим язык для пунктов меню
      this.topMenu_lang = [];
      for (var i = 0; i < 8; ++i) {
        this.topMenu_lang.push(res[i + 1],)
      }

      //добавим язык для пунктов субменю
      this.road_editor_lang = res[9];
      this.road_type = res[10];
      this.lane_type = res[11];
      this.cabinets_lang = res[12];
      this.sensors_lang = res[13];
      this.adapters_lang = res[14];

      //console.log('this.topMenu_lang',this.topMenu_lang);
      if (Boolean(this.Globals.user)) {
        this.getRoadSubMenu();
        this.getEquipmentSubMenu(this.Globals.user.role.privileges);
        this.topMenuBuild();
      }
    });
  }

  public getRoadSubMenu() {
    return this.roadPages = [
      //{ link: "/road-management", name: this.roads },
      {link: "/admin/roads", name: this.road_editor_lang},
      {link: "/admin/roads/road-types", name: this.road_type},
      {link: "/admin/roads/lane-types", name: this.lane_type},

    ];
  }

  public getEquipmentSubMenu(user_privs) {

    //проверяем привилегии на адаптер

    let adapter_priv = user_privs.find(priv => priv.privileges_id == '891ea20b-8cbc-0c8b-3ccf-54f4d66d9161');

    if (Boolean(adapter_priv)) {
      return this.equipment_menu = [
        //{ link: "/cabinets", name: this.cabinets_lang }, //@yubox комментим временно шкафы в верхнем меню
        {link: "/admin/admin-sensors", name: this.sensors_lang},
        {link: "/admin/adapters-list", name: this.adapters_lang},
        {link: "/admin/admin-cabinets", name: this.cabinets_lang}
      ];
    } else {
      return this.equipment_menu = [
        //{ link: "/cabinets", name: this.cabinets_lang }, //@yubox комментим временно шкафы в верхнем меню
        {link: "/admin/admin-sensors", name: this.sensors_lang}
      ];
    }

  }

  changeProjectSelect(e) {
    localStorage.setItem('project', e);
    this.changeProject();
  }

  changeProject(projectId?: string) {
    this.Globals.select_project = localStorage.getItem('project') ? localStorage.getItem('project') : this.Globals.select_project;
    this.Globals.reload_project = true;
    this.Globals.chProj.next(this.Globals.select_project);
    this.Globals.selectedProjectId = this.Globals.select_project;

  }

  ngOnDestroy() {
    if (Boolean(this.user_sub))
      this.user_sub.unsubscribe();
    if (Boolean(this.changeLangCancel))
      this.changeLangCancel.unsubscribe();
    if (Boolean(this.langSubscription))
      this.langSubscription.unsubscribe();
  }
}
